import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import TextField from "@mui/material";
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  FormControl,
  FormHelperText,
  Stack,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../components/MaterialTypography";

import MaterialBox from "../components/MaterialBox";
import MaterialInput from "../components/MaterialInput";

import MaterialButton from "../components/MaterialButton";

import DashboardLayout from "../layoutcontainers/DashboardLayout";
import SelectPlaceholder from "./Selecttool";
import MaterialSelect from "../components/MasterSelect";
import { useUserDetails } from "../context/auth";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Paper,
  ButtonGroup
} from "@mui/material";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import BASEURL from "../pages/Utils/Baseurl";
import axios from "axios";
import React from "react";
import ConfirmationDialog from "../components/Dialog/ConfirmationDialog";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { UpdateSourceScreen,Allstaffrequestquery,GetAllTechnical } from "./Graphql";
const tableStyles = {
  table: {
    borderCollapse: "collapse",
    // width: "90%", // Increased width
    margin: "0 auto", // Center the table
    // boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    borderRadius: "6px",
    "& th, & td": {
      border: "1px solid #ddd",
      textAlign: "center",
      padding: "6px 40px", // Reduced padding for lower height
    },
    "& th": {
      backgroundColor: "#3F51B5d4",
      color: "#fff",
      fontWeight: "600",
      fontSize: "0.9rem",
      textTransform: "uppercase",
    },
    "& td": {
      fontSize: "0.85rem",
    },
    "& tr:hover td": {
      // backgroundColor: "#f3f3f3",
    },
  },
};

const validateInput = (value, type) => {
  switch (type) {
    case "email":
      return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value);
    case "number":
      return /^\d+$/.test(value);
    case "text":
      return value.trim() !== "";
    case "date":
      return value != "" && value != null;
    case "phoneno":
      return /^\d{10}$/.test(value);
    case "select":
      return value != "" && value != null;
    case "autogen":
      return value != "" && value != null;
    case "name":
      const nameRegex = /^[a-zA-Z]{4,15}$/;
      return nameRegex.test(value);
    default:
      return true;
  }
};

const SourceProfile = () => {
  const [selectedRatings, setSelectedRatings] = useState({});
  const characteristics = [
    "Professionalism",
    "Technical Skills",
    "Level of Interest",
    "Learning Ability",
    "Confidence",
    "Attitude",
    "Communication",
  ];
  const navigate = useNavigate();
    const {AccessData} = useUserDetails()
    const [id, setId] = useState(null);
    const [Noposition,setNoposition] = useState('')

    const [DataValue,setDataValue] = useState([])
    const [AllTech,setAllTech] = useState([])

  const ratings = ["Poor", "Fair", "Average", "Good", "Excellent"];

  const ratingValues = {
    Poor: 1,
    Fair: 2,
    Average: 3,
    Good: 4,
    Excellent: 5,
  };

  const handlefeedbback = (event) => {
    const { name, value } = event.target;

    setSelectedRatings((prev) => ({
      ...prev,
      [name]: ratingValues[value],
    }));
  };


  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });

  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  const [feedback, setfeedback] = useState({
    jobid: "",
    candidatename: "",
    date: "",
    position: "",
    department: "",
    interviewer: "",
    comments: "",
    hiringstatus: "",

    jobidStatus: "unchecked",
    candidatenameStatus: "unchecked",
    dateStatus: "unchecked",
    positionStatus: "unchecked",
    departmentStatus: "unchecked",
    interviewerStatus: "unchecked",
    commentsStatus: "unchecked",
    hiringstatusStatus: "unchecked",
  });

  const jobidlist = [
    { value: "Hired", label: "Hired" },
    { value: "Rejected", label: "Rejected" },
    { value: "Immediate", label: "Immediate" },
    { value: "On hold", label: "On hold" },
    { value: "1 Month", label: "1 Month" },
    { value: "2 Month", label: "2 Month" },
    { value: "3 Month", label: "3 Month" },
  ];
 
  const [Originalfeedback, setOriginalfeedback] = useState({
    jobid: "",
    candidatename: "",
    date: "",
    position: "",
    department: "",
    interviewer: "",
    comments: "",
    hiringstatus: "",

    jobidStatus: "unchecked",
    candidatenameStatus: "unchecked",
    dateStatus: "unchecked",
    positionStatus: "unchecked",
    departmentStatus: "unchecked",
    interviewerStatus: "unchecked",
    commentsStatus: "unchecked",
    hiringstatusStatus: "unchecked",
  });

  const [alldata,setalldata] = useState([])

useEffect(()=>{
  allquerydata();
},[id])

const allquerydata = async () => {
  try {
    const [response1, response2] = await Promise.all([
      axios.post(
        BASEURL,
        { query: Allstaffrequestquery }, // Corrected here
        { headers: { "Content-Type": "application/json" } }
      ),
      axios.post(
        BASEURL,
        { query: GetAllTechnical }, // This is already correct
        { headers: { "Content-Type": "application/json" } }
      ),
    ]);


    let result = response2.data.data.allTechnicalFeedback

    let finaldata = response1.data.data.allStaffRequests

    setalldata(finaldata)

     let filt = result.filter((val)=> val.id == id)

  } catch (error) {
  }
};


  const Selectoptions = {
    1: ["001", "002", "003"],
    6: ["person1", "person2"],
  };

  const [select, setselect] = useState({
    1: { value: "" },
    6: { value: "" },
  });

  const [disablebutton, setdisablebutton] = useState(true);

  const fields = [
    { id: 1, label: "Job ID*", type: "select" },
    { id: 2, label: "Candidate Name", type: "name" },
    { id: 3, label: "Date", type: "date" },
    { id: 4, label: "Position", type: "autogen" },
    { id: 5, label: "Department", type: "autogen" },
    { id: 6, label: "Interviewer", type: "select" },
  ];

  const [inputs, setInputs] = useState(
    fields.reduce((acc, field) => {
      acc[field.id] = { value: "", error: "" };
      return acc;
    }, {})
  );



  const [feedId,setfeedId] = useState(null)
  const [RealStatus,setRealStatus] = useState(false)

  React.useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    const dataid = queryParams.get("dataid");
    setId(id);
    if (id) {
      getInitData(id);
    } else {
      // setPageState((prevState) => ({
      //   ...prevState,
      //   loading: false,
      //   state: "default",
      // }));
    }
    if(dataid){
      setfeedId(dataid)
      getfeedback(dataid);
     
    }
  }, []);

  useEffect(()=>{
    Filtalldata();
  },[alldata,DataValue])

  const Filtalldata = async()=>{
    let result = alldata.filter((dat)=> dat.jobid == DataValue.jobid)
    let DD = result[0]?.noOfPositions
    setNoposition(DD)


    const query1 = `query GetAllTechnicalFeedback {
      allTechnicalFeedback {
        id
        comments
        hiringStatus
        professionalism
        technicalSkills
        communication
        sourcingScreening {
          id
          candidateName
          jobid
        }
      }
    }`;

    try {

      const response = await axios.post(
        BASEURL,
        {
          query: query1,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );


      let Val = response.data.data.allTechnicalFeedback ;

      setAllTech(Val)

      let Datafill = Val.filter((val) => val?.sourcingScreening?.jobid == DataValue.jobid);

      let Final = Datafill.filter((val) => 
        val.hiringStatus === 'Hired' || 
        val.hiringStatus === 'Immediate' || 
        val.hiringStatus === '1 Month' || 
        val.hiringStatus === '2 Month' || 
        val.hiringStatus === '3 Month'
      );
      


      if(DD <= Final.length){
      
        
      }else{
         
      }

    } catch (error) {
    }

  }

  const getInitData = async (id) => {
    const query = `query GetSourcingScreeningById($id: ID!) {
sourcingScreening(id: $id) {
  id
  jobid
  candidateName
  source
  emailid
  mobileNumber
  totalExperience
  relevantExperience
  currentCtc
  expectedCtc
  leadTime
  yearOfPassing
  currentEmployer
  location
  comments
  interviewAvailability
  interviewer
  cvFile
     department
    position
}
}`;

    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: { id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      let result = response.data.data.sourcingScreening;
    
      setDataValue(result)
      const interviewDate = new Date(result.interviewAvailability);

//  setTimeout(() => {
//   let filt = alldata.filter((val)=> val.jobid == result.jobid)
  
//  }, 5000);
       

      // Convert to Indian Standard Time
      const indianTime = new Date(
        interviewDate.toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
      );

      const formattedDate = indianTime
        .toISOString()
        .slice(0, 19)
        .replace("T", " ");

        setfeedback((prevFeedback) => ({
          ...prevFeedback,
          jobid: result.jobid,
          candidatename: result.candidateName,
          interviewer: result.interviewer,
          position: result.position,
          department: result.department,
          date: formattedDate,
        }));
      setOriginalfeedback({
        ...feedback,
        // jobid: { value: result.jobid, label: result.jobid },
        jobid: result.jobid,
        candidatename: result.candidateName,
        interviewer: result.interviewer,
        position: result.position,
        department: result.department,
        date: formattedDate,
      });

     

     
    } catch (error) {
      console.error("ResponseError:", error);
      setConfirmationDialog({
        open: true,
        title: "Error massage",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const getfeedback = async (id) => {
    setRealStatus(true)
    const query = `query GetTechnicalFeedbackById($id: ID!) {
  technicalFeedbackById(id: $id) {
    id
    comments
    hiringStatus
    professionalism
    technicalSkills
    levelOfInterest
    learningAbility
    confidence
    attitude
    communication
    sourcingScreening {
      id
      candidateName
    }
  }
}
`;

    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: { id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );


      let result = response.data.data.technicalFeedbackById;

      let splitfuntion = (value) => {
        let data = value?.split('_').pop();
    
        let integerData = parseInt(data, 10); 
      
      
        return integerData;
      };

      setSelectedRatings({
        ...selectedRatings,

        professionalism: splitfuntion(result.professionalism),
        technicalSkills: splitfuntion(result.technicalSkills),
        levelOfInterest: splitfuntion(result.levelOfInterest),
        learningAbility: splitfuntion(result.learningAbility),
        confidence: splitfuntion(result.confidence),
        attitude: splitfuntion(result.attitude),
        communication: splitfuntion(result.communication ),
      });
     
    
      setfeedback((prevFeedback) => ({
        ...prevFeedback,
        comments: result.comments,
        hiringstatus: { value: result.hiringStatus, label: result.hiringStatus },
      }));
        setOriginalfeedback(prevFeedback => ({
          ...prevFeedback, // Preserve existing state
          comments: result.comments,
          hiringstatus: { value: result.hiringStatus, label: result.hiringStatus }
        }));
   

      setTogglePage({
        ...togglePage,
        view: true,
      });

    } catch (error) {
    }
  };



  

  const handleSubmit = (e) => {
    e.preventDefault();

    let isValid = true;
    const updatedInputs = { ...inputs };

    // Loop over fields to validate each one
    fields.forEach((field) => {
      const { id, type } = field;
      const value = updatedInputs[id].value;

      if (!validateInput(value, type)) {
        updatedInputs[id].error = `${field.label} is invalid`;
        isValid = false;
      }
    });

    if (isValid) {
      alert("Form submitted successfully!");

      // You can process the form data here
    } else {
      setInputs(updatedInputs);
    }
  };

  const [Displayerror,setDisplayerror] = useState(false)
  const [Displayerror1,setDisplayerror1] = useState(false)


  const handleScreenChange = (event, selectEvent) => {
    let sourceState = { ...feedback };

    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "jobid") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          sourceState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          sourceState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }

      if (selectEvent.name === "hiringstatus") {
        const lengthRegex = /^[A-Za-z0-9\s]+$/;
         {!RealStatus &&
          (() => {
            if (
              event.label === 'Hired' || 
              event.label === 'Immediate' || 
              event.label === '1 Month' || 
              event.label === '2 Month' || 
              event.label === '3 Month'
            ) {
              let Datafill = AllTech.filter((val) => val?.sourcingScreening?.jobid === DataValue.jobid);
            
              let Final = Datafill.filter((val) => 
                val.hiringStatus === 'Hired' || 
                val.hiringStatus === 'Immediate' || 
                val.hiringStatus === '1 Month' || 
                val.hiringStatus === '2 Month' || 
                val.hiringStatus === '3 Month'
              );

              
        
              if (Final?.length >= Noposition) {
                setDisplayerror(true);
              } else {
                setDisplayerror(false);
              }
        
            }else {
              setDisplayerror(false)
            }
            return null; // JSX requires a return statement inside the function
          })()
        }
         {RealStatus &&
          (() => {
            if (
              event.label === 'Hired' || 
              event.label === 'Immediate' || 
              event.label === '1 Month' || 
              event.label === '2 Month' || 
              event.label === '3 Month'
            ) {
              const validStatuses = ['Hired', 'Immediate', '1 Month', '2 Month', '3 Month'];
              let Datafill = AllTech.filter((val) => val?.sourcingScreening?.jobid === DataValue.jobid);

            let Final = Datafill.filter((val) => validStatuses.includes(val.hiringStatus));
           
            if (Noposition <= Final.length) {
              setDisplayerror1(true)
            } else {
              setDisplayerror1(false)
            }
        
            }else {
              setDisplayerror1(false)
            }
            return null; // JSX requires a return statement inside the function
          })()
        }
         
        // {RealStatus &&
        //   (() => {
        //     const validStatuses = ['Hired', 'Immediate', '1 Month', '2 Month', '3 Month'];
        
        //     let Final = AllTech.filter((val) => validStatuses.includes(val.hiringStatus));
        
        //     if (Noposition <= Final.length) {
        //       setDisplayerror1(true)
        //     } else {
        //       setDisplayerror1(false)
        //     }
        //   })()
        // }
        

        if (lengthRegex.test(event?.label) === true) {
          sourceState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          sourceState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      sourceState[selectEvent.name] = event;
    } else {
      const changeAllowed = true;
      switch (event.target.name) {
        case "candidatename":
          {
            const alphaNumberLengthRegex = new RegExp("^([a-zA-Z ]{1,40})$");
            // const alphaNumberLengthRegex = new RegExp('^([A-Za-z]{1,15})$');

            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              sourceState[event.target.name + "Status"] = "success";
            } else {
              sourceState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "date":
          {
            if (event.target.value?.trim()) {
              sourceState[event.target.name + "Status"] = "success";
              const dateOnly = event.target.value.split("T")[0];
            } else {
              sourceState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "position":
          {
            const alphaNumberLengthRegex = new RegExp("^([a-zA-Z ]{1,40})$");
            // const alphaNumberLengthRegex = new RegExp('^([A-Za-z]{1,15})$');

            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              sourceState[event.target.name + "Status"] = "success";
            } else {
              sourceState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "department":
          {
            const alphaNumberLengthRegex = new RegExp("^([a-zA-Z ]{1,40})$");
            // const alphaNumberLengthRegex = new RegExp('^([A-Za-z]{1,15})$');

            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              sourceState[event.target.name + "Status"] = "success";
            } else {
              sourceState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "interviewer":
          {
            const alphaNumberLengthRegex = new RegExp("^([a-zA-Z ]{1,40})$");
            // const alphaNumberLengthRegex = new RegExp('^([A-Za-z]{1,15})$');

            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              sourceState[event.target.name + "Status"] = "success";
            } else {
              sourceState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "comments":
          {
            const alphaNumberLengthRegex = new RegExp("^([a-zA-Z ]{1,250})$");
            // const alphaNumberLengthRegex = new RegExp('^([A-Za-z]{1,15})$');

            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              sourceState[event.target.name + "Status"] = "success";
            } else {
              sourceState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
      }
      if (changeAllowed) {
        sourceState[event.target.name] = event.target.value;
      }
    }
    setfeedback(sourceState);
  };


  const handleAddSource = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to submit your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        handleSubmitFeedback();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const handleSubmitFeedback = async () => {
    const query = `mutation CreateTechnicalFeedback($input: TechnicalFeedbackInput!) {
  createTechnicalFeedback(input: $input) {
    technicalFeedback {
      id
      sourcingScreening {
        id
        candidateName
      }
      professionalism
      comments
      hiringStatus
      technicalSkills
      levelOfInterest
      learningAbility
      confidence
      attitude
      communication
    }
  }
}`;

    const alldata = {
      sourcingScreeningId: id,
      comments: feedback.comments,
      hiringStatus: feedback.hiringstatus.value,
      professionalism: selectedRatings.professionalism,
      technicalSkills: selectedRatings.technicalSkills,
      levelOfInterest: selectedRatings.levelOfInterest,
      learningAbility: selectedRatings.learningAbility,
      confidence: selectedRatings.confidence,
      attitude: selectedRatings.attitude,
      communication: selectedRatings.communication,
    };


    try {
      const response = await axios.post(BASEURL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        query,
        variables: {
          input: alldata,
        },
      });

      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });

      const finaldata =
        response.data.data?.createTechnicalFeedback?.technicalFeedback;

      if (finaldata !== "") {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Feedback Submitted Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/technical");
      }
    } catch (error) {
      console.error("responseError:", error);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvenience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };


  const AddDelete = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onDeleteStaff();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const onDeleteStaff = async () => {
    const query = `
      mutation DeleteFeedback($id: ID!) {
  deleteTechnicalFeedback(id: $id) {
    success
  }
}

        `;

    // try {
    //   const response = await axios.post(BASEURL, {
    //     query: query,
    //     variables: {
    //       id: feedId,
    //     },
    //   });

    //   const responseData = response.data;


    //   if (responseData.data.deleteTechnicalFeedback.success) {
    //     navigate("/technical");
    //     Swal.fire({
    //       position: "center",
    //       icon: "success",
    //       title: "Feedback Deleted Successfully!",
    //       showConfirmButton: false,
    //       timer: 2500,
    //     });
    //   } else {
    //   }
    // } catch (error) {
    //   console.error("An error occurred while deleting the wfh:", error);
    // }

    const alldata = {
     
      screeningStatus: 'Rejected',  
    
    };
    try {
      const [response1, response2] = await Promise.all([
        axios.post(
          BASEURL,
          {
            query: query,
            variables: {   id: feedId,},
          },
          { headers: { "Content-Type": "application/json" } }
        ),
        axios.post(
          BASEURL,
          {
            query: UpdateSourceScreen,
            variables: {
              id: id,
              input: alldata,
            },
          },
          { headers: { "Content-Type": "application/json" } }
        ),
      ]);


      let result = response1.data.deleteTechnicalFeedback;

      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });

      if (response1.data.data.deleteTechnicalFeedback.success) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Feedback Deleted Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/technical");
        // setChangevalue({
        //   ...Changevalue,
        //   Changevalue: "Asset Request",
        // });
      }
    } catch (error) {
    }

  };

  const handleEdit = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to Update your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        Updatestaffrequest();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const Updatestaffrequest = async () => {
    const query = `
   mutation UpdateTechnicalFeedback($id: ID!, $input: TechnicalFeedbackInput!) {
  updateTechnicalFeedback(id: $id, input: $input) {
    technicalFeedback {
      id
      professionalism
      comments
      hiringStatus
      technicalSkills
      levelOfInterest
      learningAbility
      confidence
      attitude
      communication
    }
  }
}
  `;

    // Ensure staffrequest object is correctly populated
    const alldata = {
      comments: feedback.comments,
      hiringStatus: feedback.hiringstatus.value,
      professionalism: selectedRatings.professionalism,
      technicalSkills: selectedRatings.technicalSkills,
      levelOfInterest: selectedRatings.levelOfInterest,
      learningAbility: selectedRatings.learningAbility,
      confidence: selectedRatings.confidence,
      attitude: selectedRatings.attitude,
      communication: selectedRatings.communication,
    };

    

    try {
      const response = await axios.post(BASEURL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        query,
        variables: {
          id : feedId,
          input: alldata,
        },
      });


      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });

      let finaldata = response.data.data.updateTechnicalFeedback.technicalFeedback

      if(finaldata !== ''){
          Swal.fire({
                position: "center",
                icon: "success",
                title: "Feedback Updated Successfully!",
                showConfirmButton: false,
                timer: 2500,
              });
              navigate('/technical')
      }

    } catch (error) {
      // Handle network or unexpected errors
      console.error("Network or unexpected error:", error);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for the inconvenience, there is an issue with our network. Please try again later.",
        showCancel: true,
        showConfirm: false,
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const handleDiscard = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to discard your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onDiscardWfh();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const onDiscardWfh = () => {
    setTogglePage({
      view: true,
      edit: false,
    });

    setfeedback({
      jobid:Originalfeedback.jobid,
      candidatename:Originalfeedback.candidatename,
      interviewer:Originalfeedback.interviewer,
      position: Originalfeedback.position,
      department: Originalfeedback.department,
      date: Originalfeedback.date,
      comments: Originalfeedback.comments,
      hiringstatus: Originalfeedback.hiringstatus
    })
   
    setConfirmationDialog({
      ...confirmationDialog,
      open: false,
    });
  };
  const checkAllFields = () => {
    let allowSubmit = false;
    if (
     
      feedback.hiringstatusStatus === "success"&&
      feedback.commentsStatus === "success" && 
      !Displayerror
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };
  const checkAllFields1 = () => {
    let allowSubmit = false;
    if (
     
     
      !Displayerror1
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };
  const handlecancel = ()=>{
    navigate('/technical')
  }
  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Card>
      <CardHeader
                  title={
                    <>
                      {togglePage.view === true || togglePage.edit === true ? (
                        <Stack
                          direction="row"
                          justifyContent="space-between"
                          alignItems="center"
                          spacing={2}
                        >
                          <Stack direction="column" spacing={0}>
                            <MaterialTypography
                              variant="h5"
                              fontWeight="medium"
                            >
                              Edit Feedback
                            </MaterialTypography>
                          </Stack>
                          {AccessData &&
                            Array.isArray(AccessData) &&
                            AccessData.some(
                              (item) =>
                                item.component === "EditTechnicalFeedback" &&
                                item.can_access
                            ) &&
                            pageState.state !== "submitting" && (
                              <ButtonGroup
                                variant="outlined"
                                aria-label="Loading button group"
                              >
                                <MaterialButton
                                  variant="gradient"
                                  color="dark"
                                  onClick={toggleEdit}
                                  startIcon={<EditIcon />}
                                >
                                  Edit
                                </MaterialButton>
                                <MaterialButton
                                  variant="gradient"
                                  color="dark"
                                  onClick={AddDelete}
                                  startIcon={<DeleteIcon />}
                                >
                                  Delete
                                </MaterialButton>
                              </ButtonGroup>
                            )}
                        </Stack>
                      ) : (
                        <Stack
                          direction="row"
                          justifyContent="space-between"
                          alignItems="center"
                          spacing={2}
                        >
                          <Stack direction="column" spacing={0}>
                            <MaterialTypography
                              variant="h5"
                              fontWeight="medium"
                            >
                              Add Feedback
                            </MaterialTypography>
                          </Stack>
                        </Stack>
                      )}
                    </>
                  }
                />
        <CardContent>
          <MaterialBox>
            <Grid container spacing={2}>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Job ID <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="jobid"
                  value={feedback.jobid}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleScreenChange}
                  // options={jobidlist.map((value) => {
                  //   return {
                  //     value: value.value,
                  //     label: value.label,
                  //   };
                  // })}
                  error={feedback.jobidStatus === "error" ? true : false}
                  success={feedback.jobidStatus === "success" ? true : false}
                  disabled={true}
                  //   isClearable
                />
                {feedback.jobidStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>Job ID is Mandatory</FormHelperText>
                  </FormControl>
                )}
              </Grid>

              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Candidate Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="candidatename"
                  value={feedback.candidatename}
                  onChange={handleScreenChange}
                  customStyles={{ optionPadding: 20 }}
                  error={
                    feedback.candidatenameStatus === "error" ? true : false
                  }
                  success={
                    feedback.candidatenameStatus === "success" ? true : false
                  }
                  disabled={true}
                  //   isClearable
                />
                {feedback.candidatenameStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>Requested Date is Mandatory</FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Interview Date <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="date"
                  type="datetime-local"
                  value={feedback.date}
                  onChange={handleScreenChange}
                  customStyles={{ optionPadding: 20 }}
                  error={feedback.dateStatus === "error" ? true : false}
                  success={feedback.dateStatus === "success" ? true : false}
                  disabled={togglePage.view === true ? true : false}
                  //   isClearable
                />
                {feedback.dateStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>Requested Date is Mandatory</FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Position <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="position"
                  value={feedback.position}
                  onChange={handleScreenChange}
                  customStyles={{ optionPadding: 20 }}
                  error={feedback.positionStatus === "error" ? true : false}
                  success={feedback.positionStatus === "success" ? true : false}
                  disabled={true}
                  //   isClearable
                />
                {feedback.positionStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>Requested Date is Mandatory</FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Department <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="department"
                  value={feedback.department}
                  onChange={handleScreenChange}
                  customStyles={{ optionPadding: 20 }}
                  error={feedback.departmentStatus === "error" ? true : false}
                  success={
                    feedback.departmentStatus === "success" ? true : false
                  }
                    disabled={true}
                  //   isClearable
                />
                {feedback.departmentStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>Requested Date is Mandatory</FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Interviewer <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="interviewer"
                  value={feedback.interviewer}
                  onChange={handleScreenChange}
                  customStyles={{ optionPadding: 20 }}
                  error={feedback.interviewerStatus === "error" ? true : false}
                  success={
                    feedback.interviewerStatus === "success" ? true : false
                  }
                    disabled={togglePage.view === true ? true : false}
                  //   isClearable
                />
                {/* {feedback.interviewerStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>Requested Date is Mandatory</FormHelperText>
                  </FormControl>
                )} */}
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <Table sx={tableStyles.table}>
                  <TableHead>
                    <TableRow>
                      <TableCell>Characteristics</TableCell>
                      {ratings.map((rating) => (
                        <TableCell key={rating}>{rating}</TableCell>
                      ))}
                    </TableRow>

                    <TableBody>
                    {characteristics.map((char, index) => {
  // Convert to camelCase to match selectedRatings keys
  const charKey = char
    .split(" ")
    .map((word, idx) =>
      idx === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    )
    .join("");


  return (
    <TableRow key={`${char}-${index}`}>
      <TableCell>{char}</TableCell>
      {ratings.map((rating) => (
        <TableCell key={`${char}-${rating}`}>
          <Checkbox
            name={charKey}
            value={rating}
            disabled={togglePage.view}
            color="primary"
            checked={selectedRatings[charKey] === ratingValues[rating]}
            onChange={handlefeedbback}
          />
        </TableCell>
      ))}
    </TableRow>
  );
})}


                    </TableBody>
                  </TableHead>
                </Table>
              </Grid>
            </Grid>

            <Grid marginTop={2} container spacing={2}>
              <Grid size={{ xs: 5, sm: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Comments <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="comments"
                  multiline
                  rows={4}
                  value={feedback.comments}
                  onChange={handleScreenChange}
                  customStyles={{ optionPadding: 20 }}
                  error={feedback.commentsStatus === "error" ? true : false}
                  success={feedback.commentsStatus === "success" ? true : false}
                    disabled={togglePage.view === true ? true : false}
                  //   isClearable
                />
                {feedback.commentsStatus === "error" && (
                  <FormControl error>
                    <FormHelperText> Comments accept maximum 250 characters.</FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Hiring Status <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="hiringstatus"
                  value={feedback.hiringstatus}
                  // customStyles={{ optionPadding: 20 }}
                  onChange={handleScreenChange} //selectedValue, event
                  options={jobidlist.map((value) => {
                    return {
                      value: value.value,
                      label: value.label,
                    };
                  })}
                  error={feedback.hiringstatusStatus === "error" ? true : false}
                  success={
                    feedback.hiringstatusStatus === "success" ? true : false
                  }
                 
                    isDisabled={togglePage.view === true ? true : false}
                  //   isClearable
                />
                 {Displayerror && (
                  <FormControl error>
                    <FormHelperText>Cannot Hire more than the Requested positions.</FormHelperText>
                  </FormControl>
                )}
                 {Displayerror1 && (
                  <FormControl error>
                    <FormHelperText> Cannot convert On Hold profiles to Selected status as selected candidates exceed available positions.</FormHelperText>
                  </FormControl>
                )}
              </Grid>
            </Grid>

            {/* </TableContainer> */}
          </MaterialBox>
{/* 
          <MaterialBox
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            <MaterialButton
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
              // disabled={disablebutton}
              onClick={handleAddSource}
            >
              Submit
            </MaterialButton>
          </MaterialBox> */}
               {/* <MaterialBox
                                   display="flex"
                                   justifyContent="flex-end"
                                   alignItems="center"
                                   sx={{ marginTop:10}}
                                 >

                                   {(togglePage.edit === true || togglePage.view === true) && (
                                                         <MaterialButton
                                                           variant="gradient"
                                                           color="dark"
                                                           sx={{ m: 2 }}
                                                           onClick={handlecancel} 
                                                         >
                                                           Close
                                                         </MaterialButton>
                                                       )}
                                   {togglePage.edit === true ? (
                                     <>
                                       <MaterialButton
                                         variant="gradient"
                                         color="dark"
                                         disabled={pageState.state === "submitting"}
                                         onClick={handleDiscard}
                                       >
                                         Discard
                                       </MaterialButton>
                                       <MaterialButton
                                         sx={{ m: 2 }}
                                         variant="gradient"
                                         color="dark"
                                         disabled={pageState.state === "submitting"}
                                          onClick={handleEdit}
                                       >
                                         update
                                       </MaterialButton>
                                     </>
                                   ) : togglePage.view === false && togglePage.edit === false ? (
                                    <>
                                     <MaterialButton
                                       sx={{ marginTop:14}}
                                       variant="gradient"
                                       color="dark"
                                      //  disabled={
                                      //    !checkAllFields() || pageState.state === "submitting"
                                      //  }
                                      //  onClick={handlecancel}
                                     >
                                       Cancel
                                     </MaterialButton>
                                     <MaterialButton
                                      
                                       variant="gradient"
                                       color="dark"
                                       disabled={
                                         !checkAllFields() 
                                       }
                                       onClick={handleAddSource}
                                     >
                                       Submit
                                     </MaterialButton>
                                    
                                     </>
                                   ) : null}
          
                                 </MaterialBox> */}
                                 <MaterialBox
                                                      display="flex"
                                                      justifyContent="flex-end"
                                                      alignItems="center"
                                                    >
                                                      {/* Left side: Close button (Only visible when editing or viewing) */}
                                                      {(togglePage.edit === true || togglePage.view === true) && (
                                                        <MaterialButton
                                                          variant="gradient"
                                                          color="dark"
                                                          sx={{ m: 2 }}
                                                          onClick={handlecancel} 
                                                        >
                                                          Close
                                                        </MaterialButton>
                                                      )}
                                          
                                                      {/* Right side: Buttons */}
                                                      <MaterialBox
                                                        display="flex"
                                                        justifyContent="flex-end"
                                                        alignItems="center"
                                                        flexGrow={1}
                                                      >
                                                        {togglePage.edit === true ? (
                                                          <>
                                                            <MaterialButton
                                                              variant="gradient"
                                                              color="dark"
                                                              disabled={pageState.state === "submitting"}
                                                             //  onClick={handleDiscard}
                                                            >
                                                              Discard
                                                            </MaterialButton>
                                                            <MaterialButton
                                                              sx={{ m: 2 }}
                                                              variant="gradient"
                                                              color="dark"
                                                              disabled={!checkAllFields1()}
                                                              // disabled={pageState.state === "submitting"}
                                                              onClick={handleEdit}
                                                            >
                                                              Update
                                                            </MaterialButton>
                                                          </>
                                                        ) : togglePage.view === false && togglePage.edit === false ? (
                                                          <>
                                                            <MaterialButton
                                                              sx={{ m: 2 }}
                                                              variant="gradient"
                                                              color="dark"
                                                              onClick={handlecancel}
                                                            >
                                                              Cancel
                                                            </MaterialButton>
                                                            <MaterialButton
                                                              variant="gradient"
                                                              color="dark"
                                                              sx={{ m: 2 ,marginLeft : "2px"}}
                                                              disabled={!checkAllFields()}
                                                              onClick={handleAddSource}
                                                            >
                                                              Submit
                                                            </MaterialButton>
                                                          </>
                                                        ) : null}
                                                      </MaterialBox>
                                                    </MaterialBox>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
};
export default SourceProfile;
